import styled, { css } from '@xstyled/styled-components';
import { CarouselTinderVariants } from '../CarouselTinderStore';
import TinderCard from 'react-tinder-card';

export const CarouselItem = styled(TinderCard)<{
  variant: CarouselTinderVariants;
  index: number;
  total: number;
  disabledSwipe: boolean;
  isCurrentCardActive: boolean;
}>`
  grid-area: item;
  align-self: center;
  justify-self: center;
  z-index: ${p => p.total - p.index};
  cursor: grab;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  position: relative;
  transition: visibility 0.5s linear;

  pointer-events: ${p => (p.disabledSwipe ? 'none' : 'auto')};

  ${p =>
    p.disabledSwipe
      ? css`
    &:after {
      position absolute;
      top: 0;
      left: 0;
      min-width: 100%;
      min-height: 100%;
      border-radius: 20px;
      background-color: #0000001A;
      content: "";
    }`
      : ''}

  visibility: ${p => (p.isCurrentCardActive ? 'visible' : 'hidden')};
`;
